import Button from '@mui/material/Button/Button';
import React, { useCallback, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Skeleton } from '@mui/material';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { MantyStatus } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import EnvelopeHypothesisBaseModal from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/MantyStatusHypothesis/components/Modals/EnvelopeHypothesisBaseModal';
import { useTranslation } from 'react-i18next';
import { EnvelopeMantyStatusHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Envelope/MantyStatusHypothesis/helpers/types';

type Props = {
    isLoading: boolean;
    hrSimulation: HrSimulation;
    nonRecurrentMantyStatuses: MantyStatus[];
    mantyStatusHypotheses: EnvelopeMantyStatusHypothesis[];
};

const AddEnvelopeMantyStatusHypothesisButton = ({
    isLoading,
    hrSimulation,
    nonRecurrentMantyStatuses,
    mantyStatusHypotheses,
}: Props) => {
    const { t } = useTranslation();

    const [showModal, setShowModal] = useState(false);

    const toggleModal = useCallback(() => {
        setShowModal((current) => !current);
    }, []);

    return (
        <>
            {isLoading ? (
                <Skeleton variant="rectangular" width={200} height={40} />
            ) : (
                <>
                    <Button
                        sx={{ color: 'primary' }}
                        variant="contained"
                        startIcon={<AddIcon fontSize="small" />}
                        onClick={toggleModal}
                        disabled={hrSimulation.orgChartHrs.length === 0}
                    >
                        {t('humanResources.simulation.addEnvelope.button')}
                    </Button>
                    {showModal && (
                        <EnvelopeHypothesisBaseModal
                            open={showModal}
                            onClose={() => setShowModal(false)}
                            hrSimulation={hrSimulation}
                            nonRecurrentMantyStatuses={
                                nonRecurrentMantyStatuses
                            }
                            mantyStatusHypotheses={mantyStatusHypotheses}
                        />
                    )}
                </>
            )}
        </>
    );
};
export default AddEnvelopeMantyStatusHypothesisButton;
